import { render, staticRenderFns } from "./Trophy.vue?vue&type=template&id=2bd6e547&scoped=true&"
import script from "./Trophy.vue?vue&type=script&lang=js&"
export * from "./Trophy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6e547",
  null
  
)

export default component.exports